import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./staff_account.css";

import { useDispatch } from "react-redux";
import * as Action from "../../store/redux/staff_reducer.js";

// importing components

// Icons import
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import Logo from "../public_directory/public-routes-images/logos/Manga_Cons _Logo3.png";
// ________________________________________________________________________________________________
import CastForEducationOutlinedIcon from "@mui/icons-material/CastForEducationOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export default function StaffAccount() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.staffFunction.queue.staffData);
  const active = useSelector(
    (state) => state.staffFunction.dashboard?.nav_trace
  );
  // const [active, setActive] = useState("done");

  function AsideItem(props) {
    return (
      <span style={{ width: "90%" }}>
        <Link
          to={props.link}
          className={` itemsPf cb fx-ac  space1 ${
            active === `${props.hooks}` ? "active-prl-tab" : null
          }`}
          onClick={() => {
            handleNavigator(props.active);
            // setActive(`${props.active}`);
          }}
          style={{ padding: ".7rem 1.8rem" }}
        >
          {props.icon}
          {props.img}

          <span>{props.name}</span>
        </Link>
      </span>
    );
  }

  function logOut() {
    dispatch(DispatchLogout());
    // redirect("/staff_login");
  }
  const DispatchLogout = () => async (dispatch) => {
    try {
      dispatch(Action.logOut());
    } catch (error) {
      console.log(error);
    }
  };

  // Redux functions for dashboards navigation
  function handleNavigator(item) {
    dispatch(DispatchNavigator(item));
  }
  const DispatchNavigator = (item) => async (dispatch) => {
    try {
      dispatch(Action.dispathcDashboardNavigator({ item }));
      console.log(item);
    } catch (error) {
      console.log(error);
    }
  };
  function switchComponents() {
    switch (active) {
      case "account":
        return "account";
      case "dashboard":
        return "dashboard";
      case "Overview":
        return "Overview";
      case "calendar":
        return "calendar";
      case "Communication":
        return "Communication";
      case "Help & Support":
        return "Help & Support";
      case "setting":
        return "Change your Password here ...";
      default:
        return "Default Page";
    }
  }

  // Components

  return (
    <section className="sectionInstructorProfile">
      <div className="instructorProfileCont ">
        <div className="staffAside fx-cl fx-as space1">
          <div className="staffAsideSec fs2 cwb fx-cl fx-as ">
            <div className="fx-cl space2" style={{ width: "100%" }}>
              <figure style={{ width: "45%", alignSelf: "center" }}>
                {/* //  <img src={CompLogo} alt="" /> */}
              </figure>
              <figure className="loginLogo">
                <img src={Logo} alt="mangacons" />
              </figure>
            </div>
            <AsideItem
              name="Dashboard"
              icon={<DashboardRoundedIcon fontSize="large" />}
              hooks="dashboard"
              active="dashboard"
            />
            <AsideItem
              name="Profile Overview"
              icon={<PeopleAltRoundedIcon fontSize="large" />}
              hooks="Overview"
              active="Overview"
            />

            <AsideItem
              name="Calendar"
              icon={<AssignmentRoundedIcon fontSize="large" />}
              hooks="calendar"
              active="calendar"
            />
            <AsideItem
              name="Communication"
              icon={<CategoryRoundedIcon fontSize="large" />}
              hooks="Communication"
              active="Communication"
            />
            <AsideItem
              name="Help & Support"
              icon={<PeopleAltRoundedIcon fontSize="large" />}
              hooks="Help & Support"
              active="Help & Support"
            />

            <figure className="prfLinksto fx-ac space2 fx-jb">
              <span>Enventory</span>
              <span>Edits</span>
            </figure>
            <AsideItem
              name="Account"
              //  img={//  <img src={i3} alt="icon" />}
              active="account"
            />
            <AsideItem
              name="Setting"
              //  img={//  <img src={i3} alt="icon" />}
              active="setting"
            />

            <button
              className=" logout_staff fx-ac space1"
              onClick={() => logOut()}
            >
              <LogoutOutlinedIcon />
              <span>Logout</span>
            </button>
          </div>
        </div>
        <div className="staffHeader fx-ac fx-jb">
          <span className="fx-ac fx-jc space1">
            <span>
              <Link to="/cbt" className="fx-ac fx-jc space1">
                <CastForEducationOutlinedIcon fontSize="large" />
                <span>Student portal</span>
              </Link>
            </span>
          </span>
          <span className="fx-ac fx-jc space3">
            <span className="notifBtn fx-ac fx-jc space1">
              <NotificationsActiveOutlinedIcon fontSize="large" />
              <figure>0</figure>
            </span>
            <span className="fx-ac fx-jc space1">
              <Link
                className="fx-ac space1"
                onClick={() => handleNavigator("account")}
              >
                <p>{data.first_Name}</p>
                <figure className="dp fx-ac"></figure>
              </Link>
            </span>
          </span>
        </div>
        <div className="staffContents">{switchComponents()}</div>
      </div>
    </section>
  );
}
